import { render, staticRenderFns } from "./AiWritingDrawerComp.vue?vue&type=template&id=85382e08&scoped=true"
import script from "./AiWritingDrawerComp.vue?vue&type=script&lang=js"
export * from "./AiWritingDrawerComp.vue?vue&type=script&lang=js"
import style0 from "./AiWritingDrawerComp.vue?vue&type=style&index=0&id=85382e08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85382e08",
  null
  
)

export default component.exports